import useResponsiveDesign from 'hooks/useResponsiveDesign'
import Styles from './MobileUpdateModalsWidgetContainer.module.scss'
import { UpdateModalsWidget } from 'components/UpdateModalsWidget/UpdateModalsWidget'

export const MobileUpdateModalsWidgetContainer = () => {
  const { isMobile } = useResponsiveDesign()

  if (!isMobile) {
    return null
  }

  return (
    <div className={Styles.updateModalsWidgetContainer}>
      <UpdateModalsWidget />
    </div>
  )
}
